import { enum_ } from "valibot"

export enum WaterProximityKind {
  None = 0,
  AdjacentRidge = 1,
  Adjacent = 2,
  IsWater = 3,
}

export const WaterProximityKindSchema = enum_(WaterProximityKind, 'Invalid Water Proximity Kind')
